import { useLayoutEffect, useReducer } from 'react';
import type { ReactNode } from 'react';
import { Router } from 'react-router-dom';
import type { BrowserHistory, Update } from 'history';

type BrowserRouterType = {
  history: BrowserHistory;
  children: ReactNode;
};

// Copied from unified-login. React Router v6 does not let us inject history into
// BrowserRouter, so this keeps routing and analytics on the same history instance.
export function BrowserRouter({ children, history }: BrowserRouterType) {
  const [state, dispatch] = useReducer((_: Update, action: Update) => action, {
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(dispatch), [history]);

  return (
    <Router navigationType={state.action} location={state.location} navigator={history}>
      {children}
    </Router>
  );
}
